import dayjs from 'dayjs';

export const DATE_FORMAT = 'YYYY-MM-DD, HH:mm';

export const formatDate = (date) => {
  return date ? dayjs(date).format(DATE_FORMAT) : '⸺';
};
